import { CrmFieldType } from "../GeneratedGraphQL";
import { ExternalCrmField } from "../AppDataProvider/types";

export const optionalTextCrmField: ExternalCrmField = {
  id: "optional_text_field",
  name: "Optional Text Field",
  required: false,
  type: CrmFieldType.Text,
};
export const requiredTextCrmField: ExternalCrmField = {
  id: "required_text_field",
  name: "Required Text Field",
  required: true,
  type: CrmFieldType.Text,
};
export const optionalDateCrmField: ExternalCrmField = {
  id: "optional_date_field",
  name: "Optional Date Field",
  required: false,
  type: CrmFieldType.Date,
};
export const requiredDateCrmField: ExternalCrmField = {
  id: "required_date_field",
  name: "Required Date Field",
  required: true,
  type: CrmFieldType.Date,
};

export const crmFields = [
  optionalTextCrmField,
  requiredTextCrmField,
  optionalDateCrmField,
  requiredDateCrmField,
];
